import {
  GET_SURVEYCATEGORIE_FAIL,
  GET_SURVEYCATEGORIE_SUCCESS,
  GET_SURVEYCATEGORIES_FAIL,
  GET_SURVEYCATEGORIES_SUCCESS,
  ADD_SURVEYCATEGORIE_SUCCESS,
  ADD_SURVEYCATEGORIE_FAIL,
  UPDATE_SURVEYCATEGORIE_SUCCESS,
  UPDATE_SURVEYCATEGORIE_FAIL,
  DELETE_SURVEYCATEGORIE_SUCCESS,
  DELETE_SURVEYCATEGORIE_FAIL,  
  SET_STATE_SURVEYCATEGORIE
} from "./actionTypes";

const INIT_STATE = {
  surveyCategories: [],
  surveyCategorie: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const surveyCategories = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SURVEYCATEGORIES_SUCCESS:
      return {
        ...state,
        surveyCategories: action.payload.surveyCategories,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_SURVEYCATEGORIE:
      return { ...state, loading: action.payload }

    case GET_SURVEYCATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_SURVEYCATEGORIE_SUCCESS:
      return {
        ...state,
        surveyCategories: [...state.surveyCategories, action.payload],
      };

    case ADD_SURVEYCATEGORIE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_SURVEYCATEGORIE_SUCCESS:
      return {
        ...state,
        surveyCategories: state.surveyCategories.map(surveyCategorie =>
          surveyCategorie.id.toString() === action.payload.id.toString()
            ? { ...action.payload, surveyCategorie }
            : surveyCategorie
        ),
      };

    case UPDATE_SURVEYCATEGORIE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_SURVEYCATEGORIE_SUCCESS:
      return {
        ...state,
        surveyCategories: state.surveyCategories.filter(
          surveyCategorie => surveyCategorie.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_SURVEYCATEGORIE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_SURVEYCATEGORIE_SUCCESS:
      return {
        ...state,
        surveyCategorie: action.payload,
      };

    case GET_SURVEYCATEGORIE_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default surveyCategories;
